import { Component, h, Listen, Prop, State } from '@stencil/core';
import { QueryParamsHelpers } from '../../../../../shared/helpers/query-params.helpers';
import { replaceKey } from '../../../../../shared/helpers/replace-key.helper';
import { logout } from '../../../../../shared/helpers/logout.helper';
import { TrackerEventsEnum } from '../../../../../shared/models/tracker-events.enum';
import { sdkLogHelper } from '../../../../../shared/helpers/sdk-log.helper';
import get from 'lodash/get';

@Component({
  tag: 'cant-order-by-gender-modal',
  styleUrl: 'cant-order-by-gender-modal.scss'
})
export class CantOrderByGenderModal {
  @Prop() requiredGender: string;
  @State() isActive: boolean = false;
  consultationLinks = document.querySelectorAll('[data-consultation-link]');
  consultationHref: string = '';
  region = window['apomedsConfigs']?.region || 'en';
  _gender = window['currentUser'] ? window['currentUser']['gender'] : undefined;
  get gender(): string {
    return this._gender
      ? this._gender
      : this.requiredGender === 'male'
        ? 'female'
        : 'male';
  }

  componentWillLoad() {
    this.handleLinksClicks();
  }

  translate = (key) => {
    const translations = window['cantOrderByGenderConfig'] // For website
      || window['apomedsConfigs']?.spaTranslations?.common?.main?.cantOrderByGender?.main; // For SPA

    return get(translations, key, key);
  }

  @Listen('openCantOrderByGenderModal', { target: 'document' })
  openHandler() {
    this.isActive = true;
    this.trackPopupOpening();
  }

  handleLinksClicks() {
    this.consultationLinks.forEach((link: HTMLAnchorElement) => {
      link.addEventListener('click', (event) => {
        if (this.requiredGender && this._gender && this.requiredGender !== this._gender) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.toggleActive();
          this.consultationHref = link.getAttribute('href');
          this.trackPopupOpening();
        }
      });
    });
  }

  trackPopupOpening() {
    sdkLogHelper(TrackerEventsEnum.cantOrderByGenderPopupShown, {
      location: window.location.href,
      session_id: QueryParamsHelpers.queryParamsObject().session_id || null,
      customer: window['currentUser'] || null,
    });
  }

  toggleActive() {
    this.isActive = !this.isActive;
  }

  continueAsANewCustomer() {
    logout().finally(() => {
      if (this.consultationHref) {
        const url = new URL(window.location.origin + this.consultationHref);
        url.searchParams.delete('authToken');
        window.location.replace(`${url.toString()}`);
      } else {
        const url = new URL(window.location.href);
        url.searchParams.delete('authToken');
        window.location.replace(`${url.origin}${url.pathname}?${url.searchParams.toString()}`);
      }
    });
  }

  useAnotherAccount() {
    logout().finally(() => {
      let url = window.location.origin + window.location.pathname;
      let search = QueryParamsHelpers.queryParamsToString({
        ...QueryParamsHelpers.queryParams,
        openLoginSidebar: 'true'
      });
      window.location.replace(url + search);
    });
  }

  getGenderTranslation(gender: string) {
    return this.translate(`${gender}`);
  }

  render() {
    return <div class={`cant-order-overlay-block ${this.isActive ? 'active' : ''}`} onClick={() => this.toggleActive()}>
      <div class='modal'>
        <div class={`modal-container ${this.region === 'de' ? 'modal-container--sm' : ''}`} onClick={(e) => {
          e.stopPropagation();
        }}>
          <div id='modal-content' class='modal-content'>
            <div class='image'>
              <img src='/img/cant-order-by-gender.png' loading='lazy' alt='' />
            </div>
            <div class='title'
                 innerHTML={replaceKey(this.translate('title'), 'gender', this.getGenderTranslation(this.gender))}></div>
            <div class='subtitle'
                 innerHTML={replaceKey(this.translate('subtitle'), 'gender', this.getGenderTranslation(this.requiredGender))}></div>
            <div class='text'>
              {this.translate('text')}
            </div>
            <ul class='action-list'>
              <li class='action-item'>
                <button type='button' class='action-button btn-orange' onClick={() => this.continueAsANewCustomer()}>
                  {this.translate('newCustomer')}
                </button>
              </li>
              <li class='action-item'>
                <button type='button' class='action-button btn-blue' onClick={() => this.useAnotherAccount()}>
                  {this.translate('anotherAccount')}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>;
  }
}
